import React, { useState, useEffect, useRef } from "react";
import { Card, CardTitle, Row, Col, CardBody, Button } from "reactstrap";
import { connect } from "react-redux";
import {
  getEmpSkillById,
  addEmpSkill,
  delEmpSkillById,
} from "../../../../redux/actions/employee/employee.action";
import{getSkillCategory} from "../../../../redux/actions/adminSettings/adminSettings.action";
import api from "../../../../apis/api";
import { AddBtnSkill, AddSkillNewCat } from "./";

import {
  PopUp,
  PopUpSuccess,
} from "../../../../components/adminSettings/assets/index";
import Notifications from "../../../../components/common/Notifications";
const btnClr = ["primary", "success", "warning", "info", "danger"];
/*const skillCat = [
  "technologies",
  "Web Based Languages",
  "Desktop Based Languages",
  "Mobile App Languages",
  "Networking Technologies",
  "CRM",
  "Cloud Solutions",
  "SQL Database Languages",
  "NoSQL Database Languages",
  "Design Patterns",
  "Development Tools",
];*/
function titleCase(str) {
  var splitStr = str.toLowerCase().split(' ');
  for (var i = 0; i < splitStr.length; i++) {
      // You do not need to check if i is larger than splitStr length, as your for does that for you
      // Assign it back to the array
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
  }
  // Directly return the joined string
  return splitStr.join(' '); 
}
// CardAddSkill child component. ------------------------------------------
const CardAddSkill = ({ skillTitile, ...props }) => (
  <Card className="flex-fill">
    <CardBody>
      <CardTitle>
        <h3>{titleCase(skillTitile)}</h3>
      </CardTitle>
      {props.children}
    </CardBody>
  </Card>
);

// Parent Component. ------------------------------------------------------------------------

const TabSkill = React.memo(({ employeeId, ...props }) => {
  const { getEmpSkillById, addEmpSkill, delEmpSkillById,getSkillCategory } = props;
  //console.log(props);
  const { empSkill } = props.selectEmp;
  const {skillcategories}=props.skillcategories;
  const [whichCategorySkill, setWhichCategorySkill] = useState("");
  const [selectedCategoryId, setSelectedCatId] = useState("");
  const [newSkillId, setNewSkillId] = useState("");
  const [expertLevel, setExpertLevel] = useState("");

  const [skills, setSkills] = useState([]);
  const [empSkilllist,setempSkilllist] =useState([]);
  const [checkSkillCategory, setCheckSkillCategory] = useState([]);
  const [isOpenAddSkillCard, setIsOpenAddSkillCard] = useState(false);
  const inputEl = useRef(null);
  const [isopenpopup,setisopenpopup]=useState(false);
  const [isopenpopupSuccess,setisopenpopupSuccess]=useState(false);
  const [curDelId,setcurDelId] =useState(0);
  const [val,setval]=useState({value :"",label:""});
  const [error, setError] = useState(null);

  const [skillCat, setskillCat] = useState([]);
 // call the skillcategories data
 useEffect(() => {
  getSkillCategory();
}, [getSkillCategory]);


  // Get employee skill's employee.
  useEffect(() => {
    setskillCat(skillcategories);
    //console.log("skillcat",skillcategories);
    getEmpSkillById(employeeId);
  }, [skillcategories]);

  // Get all the skill's for dorpdown.
  useEffect(() => {
    async function fetchSkills() {
      const allSkills = await api.skill().getAllSkills();
      setSkills(allSkills.data);
    }
    fetchSkills();
  }, []);

  useEffect(() => {
    let tempArr = [];
    empSkill.map((el) => tempArr.push(el.skillCategoryName));
    //keep already in skills to a state, for checking to show/no add card.
    setCheckSkillCategory(tempArr);
  }, [empSkill]);

  // Functions. --------------------------------------------------------------
  // Handle Popover Button, to show whether new skill category add or show add form in already in category.
  const handleClickAddBtn = React.useCallback(
    (skillCatId,whichSkill) => {
      //console.log(whichSkill);
      //console.log(checkSkillCategory);
      if (!checkSkillCategory.includes(whichSkill)) {
        setIsOpenAddSkillCard(true);
        inputEl.current.scrollIntoView({ behavior: "smooth" });
      } else {
        setIsOpenAddSkillCard(false);
      }
      setWhichCategorySkill(whichSkill);
      setSelectedCatId(skillCatId);
    },
    [setWhichCategorySkill,setSelectedCatId, checkSkillCategory, inputEl]
  );

  // close btn.
  const handleCloseAddFrom = React.useCallback(() => {
    setWhichCategorySkill("");
  }, []);

  // add new skill.-------------------------------------------------------
  const handleAddNewSkill = () => {
    const bbb=empSkill;
    const filteredArray = empSkill.filter((item) =>
     item.skillCategoryId ==selectedCategoryId
    );
    if(filteredArray.length > 0)
    {
const newArray=filteredArray[0].skillName;
    const filteredArrayN = newArray.filter((item) =>
      item.skillId ==parseInt(newSkillId)
     );

     if(filteredArrayN.length >0)
      {
       setError({ ...error, message: "Skill already added...", status: 500 });
      }
      else
      {
       let formData = {
         employeeId: parseInt(employeeId),
         skillId: parseInt(newSkillId),
         expertLevel: parseInt(expertLevel),
         // lastUsed: new Date(),
         skillName: "string",
       };
       addEmpSkill(formData);
       setError({ ...error, message: "Skill added successfully...", status: 200 });
       // addSkill(newSkill, skillId, whichCategorySkill);
       setIsOpenAddSkillCard(false);
       handleCloseAddFrom();
      }
    }
    else
    {
      let formData = {
        employeeId: parseInt(employeeId),
        skillId: parseInt(newSkillId),
        expertLevel: parseInt(expertLevel),
        // lastUsed: new Date(),
        skillName: "string",
      };
      addEmpSkill(formData);
      setError({ ...error, message: "Skill added successfully...", status: 200 });
      // addSkill(newSkill, skillId, whichCategorySkill);
      setIsOpenAddSkillCard(false);
      handleCloseAddFrom();
    }
 
    //console.log(newSkillId, whichCategorySkill);
  
  };

  // Close add form.------------------------------------------------
  const toggleAddForm = () => {
    setIsOpenAddSkillCard((prevState) => !prevState);
  };

  // Handle skill name change. ---------------------------------------------
  const handleOnchangeNewSkill = (skillId) => {
    setNewSkillId(skillId);
  };

  // Handle expert level change. ---------------------------------------------
  const handleOnchangeExpertLevel = (expertLevel) => {
    setExpertLevel(expertLevel);
  };

  // Handle to delete a skill, pass employee id to fetch after deleted data's.--------------
  const handleSkillDelete = (skillId) => {
    setisopenpopup((prevState) => !prevState);
    setcurDelId(skillId);
  };
  const hadleDelWithPopYes =React.useCallback(() =>{
    // const res= delOfficeLoation(curDelId);
    delEmpSkillById(curDelId, employeeId);
   
    setisopenpopup((prevState) => !prevState);
    setisopenpopupSuccess((prevState) => !prevState);
    // window.location.reload();
   
    }, [curDelId,employeeId]);
  
  const hadleDelWithPopNo =React.useCallback(() =>{
   setisopenpopup((prevState) => !prevState);
  
  });
    
  const hadleSuccessPop =React.useCallback(() =>{
    // const fetchApi = async () => {
    //   let array=[];
    //   await api.task().GetAllTaskByProjectId(parseInt(selProjectId)).then((res) => array.push(res.data));
    //   setselAllTaskN(array[0]);
     
    // }
    // fetchApi();
     setError({ ...error, message: "Skill deleted successfully...", status: 200 });
   setisopenpopupSuccess((prevState) => !prevState);
  
  },[]);
 
  return (
    <div className="skill-box ">
      {/* {empSkill.length > 0 ? ( */}
      <Row>
        {empSkill.map((empSkill, i) => (
          <Col key={i} md="6">
            
            {/* Already in skill categories. -------------------------------------------- */}
            <Card className="flex-fill">
              <CardBody>
                <CardTitle>
                  <h3>
                    {empSkill.skillCategoryName}
                    <span
                      href="#"
                      className="edit-icon"
                      onClick={() =>
                        handleClickAddBtn(empSkill.skillCategoryId,empSkill.skillCategoryName)
                      }
                    >
                      <i className="fas fa-plus"></i>
                    </span>
                  </h3>
                </CardTitle>
                <ul className="personal-info">
                  <li>
                    {empSkill?.skillName?.map((skillName, i) => (
                      <Button key={i} color={btnClr[i]} className="mr-1 mb-1">
                        {skillName.skillName}
                        <i
                          className="fas fa-times ml-2"
                          onClick={() =>
                            handleSkillDelete(skillName.employeeSkillId)
                          }
                        ></i>
                      </Button>
                    ))}
                  </li>
                </ul>
                {/* Show add form of a corresponding skill category. */}
                {whichCategorySkill === empSkill.skillCategoryName ? (
                  <AddSkillNewCat
                    whichCategorySkill={whichCategorySkill}
                    selectedCategoryId={selectedCategoryId}
                    // skillId={empSkill.skillId}
                    // skills={skills.filter((el) => el.skillCategoryId === 1)}
                    skills={skills}
                    handleOnchangeNewSkill={handleOnchangeNewSkill}
                    handleOnchangeExpertLevel={handleOnchangeExpertLevel}
                    handleAddNewSkill={handleAddNewSkill}
                    toggleAddForm={handleCloseAddFrom}
                  ></AddSkillNewCat>
                ) : null}
              </CardBody>
            </Card>
          </Col>
        ))}
        {/* div for adding skill which is not alredy present in DOM -------------------- */}
        <Col md="6">
          {/* ref to scroll to down */}
          <div ref={inputEl}>
            {isOpenAddSkillCard && (
              <CardAddSkill skillTitile={whichCategorySkill}>
                <AddSkillNewCat
                  whichCategorySkill={whichCategorySkill}
                  selectedCategoryId={selectedCategoryId}
                  // skillId={10}
                  skills={skills}
                  handleOnchangeNewSkill={handleOnchangeNewSkill}
                  handleOnchangeExpertLevel={handleOnchangeExpertLevel}
                  handleAddNewSkill={handleAddNewSkill}
                  toggleAddForm={toggleAddForm}
                ></AddSkillNewCat>
              </CardAddSkill>
            )}
             <AddBtnSkill
        skillCat={skillCat}
        handleClickAddBtn={handleClickAddBtn}
      ></AddBtnSkill>
          </div>
         
        </Col>
             
      </Row>
      <Notifications notifications={error}></Notifications>
      {isopenpopup == true ? (<PopUp 
    
    hadleDelWithPopYes={hadleDelWithPopYes}
    hadleDelWithPopNo={hadleDelWithPopNo}
    >

</PopUp>) : null}        
{isopenpopupSuccess == true ? (<PopUpSuccess 
    hadleSuccessPop={hadleSuccessPop}
    >

</PopUpSuccess>) : null}
      {/* Add Skill button.------------------------------------------------- */}
      
    </div>
  );
});

const mapStateToProps = (state) => ({
  selectEmp: state.empReducer,
  skillcategories:state.adminSettingReducer,
});

export default connect(mapStateToProps, {
  getEmpSkillById,
  addEmpSkill,
  delEmpSkillById,
  getSkillCategory
})(TabSkill);
